module.exports = __webpack_public_path__ + "img/st7.9c244d5f.png";